import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.sort.js";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from)) if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
      get: () => from[key],
      enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
// If the importer is in node compatibility mode or this is not an ESM
// file that has been converted to a CommonJS file using a Babel-
// compatible transform (i.e. "__esModule" has not been set), then set
// "default" to the CommonJS "module.exports" for node compatibility.
isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: true
}) : target, mod));

// node_modules/fast-decode-uri-component/index.js
var require_fast_decode_uri_component = __commonJS({
  "node_modules/fast-decode-uri-component/index.js"(exports, module) {
    "use strict";

    var UTF8_ACCEPT = 12;
    var UTF8_REJECT = 0;
    var UTF8_DATA = [
    // The first part of the table maps bytes to character to a transition.
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 4, 4, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 5, 6, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 8, 7, 7, 10, 9, 9, 9, 11, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4,
    // The second part of the table maps a state to a new state when adding a
    // transition.
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 12, 0, 0, 0, 0, 24, 36, 48, 60, 72, 84, 96, 0, 12, 12, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 24, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 24, 24, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 48, 48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
    // The third part maps the current transition to a mask that needs to apply
    // to the byte.
    127, 63, 63, 63, 0, 31, 15, 15, 15, 7, 7, 7];
    function decodeURIComponent2(uri) {
      var percentPosition = uri.indexOf("%");
      if (percentPosition === -1) return uri;
      var length = uri.length;
      var decoded = "";
      var last = 0;
      var codepoint = 0;
      var startOfOctets = percentPosition;
      var state = UTF8_ACCEPT;
      while (percentPosition > -1 && percentPosition < length) {
        var high = hexCodeToInt(uri[percentPosition + 1], 4);
        var low = hexCodeToInt(uri[percentPosition + 2], 0);
        var byte = high | low;
        var type = UTF8_DATA[byte];
        state = UTF8_DATA[256 + state + type];
        codepoint = codepoint << 6 | byte & UTF8_DATA[364 + type];
        if (state === UTF8_ACCEPT) {
          decoded += uri.slice(last, startOfOctets);
          decoded += codepoint <= 65535 ? String.fromCharCode(codepoint) : String.fromCharCode(55232 + (codepoint >> 10), 56320 + (codepoint & 1023));
          codepoint = 0;
          last = percentPosition + 3;
          percentPosition = startOfOctets = uri.indexOf("%", last);
        } else if (state === UTF8_REJECT) {
          return null;
        } else {
          percentPosition += 3;
          if (percentPosition < length && uri.charCodeAt(percentPosition) === 37) continue;
          return null;
        }
      }
      return decoded + uri.slice(last);
    }
    var HEX = {
      "0": 0,
      "1": 1,
      "2": 2,
      "3": 3,
      "4": 4,
      "5": 5,
      "6": 6,
      "7": 7,
      "8": 8,
      "9": 9,
      "a": 10,
      "A": 10,
      "b": 11,
      "B": 11,
      "c": 12,
      "C": 12,
      "d": 13,
      "D": 13,
      "e": 14,
      "E": 14,
      "f": 15,
      "F": 15
    };
    function hexCodeToInt(c, shift) {
      var i = HEX[c];
      return i === void 0 ? 255 : i << shift;
    }
    module.exports = decodeURIComponent2;
  }
});

// node_modules/picoquery/lib/string-util.js
var hexTable = Array.from({
  length: 256
}, (_, i) => "%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
var noEscape = new Int8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 0]);
function encodeString(str) {
  const len = str.length;
  if (len === 0) {
    return "";
  }
  let out = "";
  let lastPos = 0;
  let i = 0;
  outer: for (; i < len; i++) {
    let c = str.charCodeAt(i);
    while (c < 128) {
      if (noEscape[c] !== 1) {
        if (lastPos < i) out += str.slice(lastPos, i);
        lastPos = i + 1;
        out += hexTable[c];
      }
      if (++i === len) break outer;
      c = str.charCodeAt(i);
    }
    if (lastPos < i) out += str.slice(lastPos, i);
    if (c < 2048) {
      lastPos = i + 1;
      out += hexTable[192 | c >> 6] + hexTable[128 | c & 63];
      continue;
    }
    if (c < 55296 || c >= 57344) {
      lastPos = i + 1;
      out += hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
      continue;
    }
    ++i;
    if (i >= len) {
      throw new Error("URI malformed");
    }
    const c2 = str.charCodeAt(i) & 1023;
    lastPos = i + 1;
    c = 65536 + ((c & 1023) << 10 | c2);
    out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
  }
  if (lastPos === 0) return str;
  if (lastPos < len) return out + str.slice(lastPos);
  return out;
}

// node_modules/picoquery/lib/shared.js
var defaultValueSerializer = value => {
  switch (typeof value) {
    case "string":
      return encodeString(value);
    case "bigint":
    case "boolean":
      return "" + value;
    case "number":
      if (Number.isFinite(value)) {
        return value < 1e21 ? "" + value : encodeString("" + value);
      }
      break;
  }
  if (value instanceof Date) {
    return encodeString(value.toISOString());
  }
  return "";
};
var defaultShouldSerializeObject = val => {
  return val instanceof Date;
};
var identityFunc = v => v;
var defaultOptions = {
  nesting: true,
  nestingSyntax: "dot",
  arrayRepeat: false,
  arrayRepeatSyntax: "repeat",
  delimiter: 38,
  valueDeserializer: identityFunc,
  valueSerializer: defaultValueSerializer,
  keyDeserializer: identityFunc,
  shouldSerializeObject: defaultShouldSerializeObject
};

// node_modules/picoquery/lib/object-util.js
function isPrototypeKey(value) {
  return value === "__proto__" || value === "constructor" || value === "prototype";
}
function getDeepObject(obj, key, nextKey, forceObject, forceArray) {
  if (isPrototypeKey(key)) return obj;
  const currObj = obj[key];
  if (typeof currObj === "object" && currObj !== null) {
    return currObj;
  }
  if (!forceObject && (forceArray || typeof nextKey === "number" || typeof nextKey === "string" && nextKey * 0 === 0 && nextKey.indexOf(".") === -1)) {
    return obj[key] = [];
  }
  return obj[key] = {};
}
var MAX_DEPTH = 20;
var strBracketPair = "[]";
var strBracketLeft = "[";
var strBracketRight = "]";
var strDot = ".";
function stringifyObject(obj, options) {
  let depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let parentKey = arguments.length > 3 ? arguments[3] : undefined;
  let isProbableArray = arguments.length > 4 ? arguments[4] : undefined;
  const {
    nestingSyntax = defaultOptions.nestingSyntax,
    arrayRepeat = defaultOptions.arrayRepeat,
    arrayRepeatSyntax = defaultOptions.arrayRepeatSyntax,
    nesting = defaultOptions.nesting,
    delimiter = defaultOptions.delimiter,
    valueSerializer = defaultOptions.valueSerializer,
    shouldSerializeObject = defaultOptions.shouldSerializeObject
  } = options;
  const strDelimiter = typeof delimiter === "number" ? String.fromCharCode(delimiter) : delimiter;
  const useArrayRepeatKey = isProbableArray === true && arrayRepeat;
  const shouldUseDot = nestingSyntax === "dot" || nestingSyntax === "js" && !isProbableArray;
  if (depth > MAX_DEPTH) {
    return "";
  }
  let result = "";
  let firstKey = true;
  let valueIsProbableArray = false;
  for (const key in obj) {
    const value = obj[key];
    let path;
    if (parentKey) {
      path = parentKey;
      if (useArrayRepeatKey) {
        if (arrayRepeatSyntax === "bracket") {
          path += strBracketPair;
        }
      } else if (shouldUseDot) {
        path += strDot;
        path += key;
      } else {
        path += strBracketLeft;
        path += key;
        path += strBracketRight;
      }
    } else {
      path = key;
    }
    if (!firstKey) {
      result += strDelimiter;
    }
    if (typeof value === "object" && value !== null && !shouldSerializeObject(value)) {
      valueIsProbableArray = value.pop !== void 0;
      if (nesting || arrayRepeat && valueIsProbableArray) {
        result += stringifyObject(value, options, depth + 1, path, valueIsProbableArray);
      }
    } else {
      result += encodeString(path);
      result += "=";
      result += valueSerializer(value, key);
    }
    if (firstKey) {
      firstKey = false;
    }
  }
  return result;
}

// node_modules/picoquery/lib/parse.js
var import_fast_decode_uri_component = __toESM(require_fast_decode_uri_component(), 1);
var regexPlus = /\+/g;
var Empty = function () {};
Empty.prototype = /* @__PURE__ */Object.create(null);
function computeKeySlice(input, startIndex, endIndex, keyHasPlus, shouldDecodeKey) {
  let chunk = input.substring(startIndex, endIndex);
  if (keyHasPlus) {
    chunk = chunk.replace(regexPlus, " ");
  }
  if (shouldDecodeKey) {
    chunk = (0, import_fast_decode_uri_component.default)(chunk) || chunk;
  }
  return chunk;
}
function parse(input, options) {
  const {
    valueDeserializer = defaultOptions.valueDeserializer,
    keyDeserializer = defaultOptions.keyDeserializer,
    arrayRepeatSyntax = defaultOptions.arrayRepeatSyntax,
    nesting = defaultOptions.nesting,
    arrayRepeat = defaultOptions.arrayRepeat,
    nestingSyntax = defaultOptions.nestingSyntax,
    delimiter = defaultOptions.delimiter
  } = options != null ? options : {};
  const charDelimiter = typeof delimiter === "string" ? delimiter.charCodeAt(0) : delimiter;
  const isJsNestingSyntax = nestingSyntax === "js";
  const result = new Empty();
  if (typeof input !== "string") {
    return result;
  }
  const inputLength = input.length;
  let value = "";
  let startingIndex = -1;
  let equalityIndex = -1;
  let keySeparatorIndex = -1;
  let currentObj = result;
  let lastKey = void 0;
  let currentKey = "";
  let keyChunk = "";
  let shouldDecodeKey = false;
  let shouldDecodeValue = false;
  let keyHasPlus = false;
  let valueHasPlus = false;
  let keyIsDot = false;
  let keyIsIndex = false;
  let hasBothKeyValuePair = false;
  let c = 0;
  let arrayRepeatBracketIndex = -1;
  let prevIndex = -1;
  let prevChar = -1;
  for (let i = 0; i < inputLength + 1; i++) {
    c = i !== inputLength ? input.charCodeAt(i) : charDelimiter;
    if (c === charDelimiter) {
      hasBothKeyValuePair = equalityIndex > startingIndex;
      if (!hasBothKeyValuePair) {
        equalityIndex = i;
      }
      if (keySeparatorIndex !== equalityIndex - 1) {
        keyChunk = computeKeySlice(input, keySeparatorIndex + 1, arrayRepeatBracketIndex > -1 ? arrayRepeatBracketIndex : equalityIndex, keyHasPlus, shouldDecodeKey);
        currentKey = keyDeserializer(keyChunk);
        if (lastKey !== void 0) {
          currentObj = getDeepObject(currentObj, lastKey, currentKey, isJsNestingSyntax && keyIsDot, isJsNestingSyntax && keyIsIndex);
        }
      }
      if (hasBothKeyValuePair || currentKey !== "") {
        if (hasBothKeyValuePair) {
          value = input.slice(equalityIndex + 1, i);
          if (valueHasPlus) {
            value = value.replace(regexPlus, " ");
          }
          if (shouldDecodeValue) {
            value = (0, import_fast_decode_uri_component.default)(value) || value;
          }
        }
        const newValue = valueDeserializer(value, currentKey);
        if (arrayRepeat) {
          const currentValue = currentObj[currentKey];
          if (currentValue === void 0) {
            if (arrayRepeatBracketIndex > -1) {
              currentObj[currentKey] = [newValue];
            } else {
              currentObj[currentKey] = newValue;
            }
          } else if (currentValue.pop) {
            currentValue.push(newValue);
          } else {
            currentObj[currentKey] = [currentValue, newValue];
          }
        } else currentObj[currentKey] = newValue;
      }
      value = "";
      startingIndex = i;
      equalityIndex = i;
      shouldDecodeKey = false;
      shouldDecodeValue = false;
      keyHasPlus = false;
      valueHasPlus = false;
      keyIsDot = false;
      keyIsIndex = false;
      arrayRepeatBracketIndex = -1;
      keySeparatorIndex = i;
      currentObj = result;
      lastKey = void 0;
      currentKey = "";
    } else if (c === 93) {
      if (arrayRepeat && arrayRepeatSyntax === "bracket") {
        if (prevChar === 91) {
          arrayRepeatBracketIndex = prevIndex;
        }
      }
      if (nesting && (nestingSyntax === "index" || isJsNestingSyntax) && equalityIndex <= startingIndex) {
        if (keySeparatorIndex !== prevIndex) {
          keyChunk = computeKeySlice(input, keySeparatorIndex + 1, i, keyHasPlus, shouldDecodeKey);
          currentKey = keyDeserializer(keyChunk);
          if (lastKey !== void 0) {
            currentObj = getDeepObject(currentObj, lastKey, currentKey, void 0, isJsNestingSyntax);
          }
          lastKey = currentKey;
          keyHasPlus = false;
          shouldDecodeKey = false;
        }
        keySeparatorIndex = i;
        keyIsIndex = true;
        keyIsDot = false;
      }
    } else if (c === 46) {
      if (nesting && (nestingSyntax === "dot" || isJsNestingSyntax) && equalityIndex <= startingIndex) {
        if (keySeparatorIndex !== prevIndex) {
          keyChunk = computeKeySlice(input, keySeparatorIndex + 1, i, keyHasPlus, shouldDecodeKey);
          currentKey = keyDeserializer(keyChunk);
          if (lastKey !== void 0) {
            currentObj = getDeepObject(currentObj, lastKey, currentKey, isJsNestingSyntax);
          }
          lastKey = currentKey;
          keyHasPlus = false;
          shouldDecodeKey = false;
        }
        keyIsDot = true;
        keyIsIndex = false;
        keySeparatorIndex = i;
      }
    } else if (c === 91) {
      if (nesting && (nestingSyntax === "index" || isJsNestingSyntax) && equalityIndex <= startingIndex) {
        if (keySeparatorIndex !== prevIndex) {
          keyChunk = computeKeySlice(input, keySeparatorIndex + 1, i, keyHasPlus, shouldDecodeKey);
          currentKey = keyDeserializer(keyChunk);
          if (isJsNestingSyntax && lastKey !== void 0) {
            currentObj = getDeepObject(currentObj, lastKey, currentKey, isJsNestingSyntax);
          }
          lastKey = currentKey;
          keyHasPlus = false;
          shouldDecodeKey = false;
          keyIsDot = false;
          keyIsIndex = true;
        }
        keySeparatorIndex = i;
      }
    } else if (c === 61) {
      if (equalityIndex <= startingIndex) {
        equalityIndex = i;
      } else {
        shouldDecodeValue = true;
      }
    } else if (c === 43) {
      if (equalityIndex > startingIndex) {
        valueHasPlus = true;
      } else {
        keyHasPlus = true;
      }
    } else if (c === 37) {
      if (equalityIndex > startingIndex) {
        shouldDecodeValue = true;
      } else {
        shouldDecodeKey = true;
      }
    }
    prevIndex = i;
    prevChar = c;
  }
  return result;
}

// node_modules/picoquery/lib/stringify.js
function stringify(input, options) {
  if (input === null || typeof input !== "object") {
    return "";
  }
  const optionsObj = options != null ? options : {};
  return stringifyObject(input, optionsObj);
}

// src/schema.ts
import { z } from "zod";
var selectionSchema = z.record(z.string(), z.string());
var paramsSchema = z.object({
  quantity: z.coerce.number().int().positive().optional(),
  productVersion: z.coerce.number().int().positive().optional(),
  deliveryOptionId: z.string().optional()
});

// src/index.ts
var selectionToQueryParameter = selection => {
  const formattedSelection = Object.keys(selection).reduce((lowerCasedSelection, key) => {
    lowerCasedSelection[key.toLowerCase()] = selection[key].toLowerCase();
    return lowerCasedSelection;
  }, {});
  return encodeURIComponent(stringify(formattedSelection));
};
var queryParameterToSelection = selectionQueryParameter => {
  if (!selectionQueryParameter) {
    throw new Error("product-code library: queryParameterToSelection()\n      - The parameter selectionQueryParameter is missing empty or not string.");
  }
  const selectionQueryParameters = decodeURIComponent(selectionQueryParameter);
  return parse(selectionQueryParameters);
};
var createProductCode = (url, selection, params) => {
  const validatedParams = paramsSchema.parse(params);
  const parsedUrl = new URL(url);
  const searchParams = new URLSearchParams(parsedUrl.search);
  if (!(validatedParams == null ? void 0 : validatedParams.productVersion) && validatedParams.quantity) {
    selection.Quantity = String(validatedParams.quantity);
  }
  if ((validatedParams == null ? void 0 : validatedParams.productVersion) && validatedParams.quantity) {
    searchParams.set("quantity", String(validatedParams.quantity));
  }
  if (validatedParams == null ? void 0 : validatedParams.deliveryOptionId) {
    searchParams.set("deliveryOptionId", validatedParams.deliveryOptionId);
  }
  if (validatedParams == null ? void 0 : validatedParams.productVersion) {
    searchParams.set("productVersion", String(validatedParams.productVersion));
  }
  const encodedSelection = selectionToQueryParameter(selection);
  searchParams.set("selection", decodeURIComponent(encodedSelection));
  parsedUrl.search = searchParams.toString();
  return parsedUrl.href;
};
var decodeProductCode = productCode => {
  var _a, _b, _c;
  try {
    const searchParams = new URLSearchParams(productCode);
    const rawSelection = searchParams.get("selection");
    if (!rawSelection) {
      throw new Error('Missing "selection" parameter in product code.');
    }
    const selection = queryParameterToSelection(rawSelection);
    const params = {
      quantity: (_a = searchParams.get("quantity")) != null ? _a : void 0,
      productVersion: (_b = searchParams.get("productVersion")) != null ? _b : void 0,
      deliveryOptionId: (_c = searchParams.get("deliveryOptionId")) != null ? _c : void 0
    };
    const decodedParams = paramsSchema.parse(params);
    return __spreadValues({
      selection
    }, decodedParams);
  } catch (_error) {
    throw new Error("Error decoding productCode");
  }
};
export { createProductCode, decodeProductCode, queryParameterToSelection, selectionToQueryParameter };